import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Chart } from 'angular-highcharts';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-speed-consumption-graph',
  templateUrl: './speed-consumption-graph.component.html',
  styleUrls: ['./speed-consumption-graph.component.scss']
})
export class SpeedConsumptionGraphComponent {
  graphChart!: Chart;
  graph: boolean = false; // Controls the container height dynamically

  ngOnInit() {
    this.renderGraph();
  }

  renderGraph() {
    const staticData = [
      { speed: 10, consumption: 12, altConsumption: 10 },
      { speed: 20, consumption: 15, altConsumption: 13 },
      { speed: 30, consumption: 18, altConsumption: 16 },
      { speed: 40, consumption: 20, altConsumption: 18 },
      { speed: 50, consumption: 25, altConsumption: 22 },
      { speed: 60, consumption: 30, altConsumption: 27 },
      { speed: 70, consumption: 35, altConsumption: 32 },
      { speed: 80, consumption: 40, altConsumption: 37 },
      { speed: 90, consumption: 45, altConsumption: 42 },
      { speed: 100, consumption: 50, altConsumption: 47 },
    ];

    const speeds = staticData.map((data) => data.speed.toString());
    const consumptions = staticData.map((data) => data.consumption);
    const altConsumptions = staticData.map((data) => data.altConsumption);

    this.graphChart = new Chart({
      chart: {
        type: 'line',
      },
      title: {
        text: 'Performance Graph',
      },
      xAxis: {
        categories: speeds,
        title: {
          text: 'Speed',
        },
      },
      yAxis: {
        title: {
          text: 'Consumption (MT)',
        },
      },
      series: [
        {
          name: 'Actual Consumption Line',
          type: 'line',
          data: consumptions,
          color: '#3d85c6',
        },
        {
          name: 'Consumption Line',
          type: 'line',
          data: altConsumptions,
          color: '#f39c12',
        },
        {
          name: 'Actual Consumption Bar',
          type: 'column',
          data: consumptions,
          color: '#2980b9',
        },
        {
          name: 'Consumption Bar',
          type: 'column',
          data: altConsumptions,
          color: '#e74c3c',
        },
      ],
      credits: {
        enabled: false,
      },
    });
  }

  toggleAEConsumption() {
    console.log('Toggled AE Consumption Only');
    // Add functionality for AE Consumption toggle here
  }

  toggleGoodWeather() {
    console.log('Toggled Good Weather Only');
    // Add functionality for Good Weather toggle here
  }
}
 